import clsx from "clsx";
import { loader } from "./svg";

/* eslint-disable react/prop-types */
const Button = ({
  type,
  text,
  size,
  disabled,
  additionalClassName,
  onClick,
  icon,
  iconPosition,
  loading,
  isPrimary = true,
}) => {
  return (
    <button
      className={clsx(
        `${additionalClassName}`,
        `group flex w-full items-center justify-center gap-2 rounded-lg ${isPrimary ? "bg-primary-500 text-[#FFFFFF] hover:bg-primary-700" : "border border-gray-700 text-gray-700 bg-white"} font-bold transition-all duration-200`,
        { "px-3.5 py-2 text-text-sm": size === "sm" },
        { "px-4.5 py-2.5 text-text-sm": size === "md" },
        { "px-7 py-4 text-text-lg": size === "lg" },
        { "!cursor-not-allowed !bg-primary-200": disabled }
      )}
      onClick={() => !loading && onClick()}
      disabled={disabled}
      type={type ?? "button"}
    >
      {/* icon */}
      {icon && !loading && (
        <div className={`${iconPosition === "end" && "order-2"}`}>{icon}</div>
      )}

      {/* text */}
      <div>{text}</div>

      {/* loader */}
      {loading && <div>{loader()}</div>}
    </button>
  );
};

export default Button;
